<template>
  <div class="customize">  
  <h1 class="card-title">{{ theme.slug }}</h1>
  
    <Timeline></Timeline>

    <Theme v-for="option in theme.options" v-bind:option="option"></Theme>

    <div class="checkout-bar">
      <div class="container">
        <div class="row d-flex justify-content-between align-items-start">
          <div class="col-8">
            <h4 class="card-title">{{ theme.name }}</h4>
            <p class="card-text">{{ theme.description }}</p>
          </div>
          <div class="col-2 text-right">
            <p class="card-price">{{ theme.price }}</p>
          </div>
          <div class="col-2 text-right">
            <button type="button" class="btn btn-primary">Save &amp; Checkout</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { dbThemesRef, dbOrdersRef } from '../firebaseConfig'
import Theme from '../components/Theme'
import Timeline from '../components/Timeline'

export default {
  name: 'Customize',
  data () {
    return {
      options: {},
      cart: []
    }
  },
  computed: {
    ...mapGetters ([
      'themes',
      'theme'
    ])
  },
  watch: {
    $route(to, from) {
     // this.updateCart()
    }
  },
  methods: {
    saveCard: function (user, name, description) {
      console.log('Saved')
    },
    updateCart() {
      // return this.$store.getters.getCartItems
    },
    createOrder() {
      // this.$store.commit('addOrder', this.basket)
      dbOrdersRef.push(this.cart)
      this.cart = []
      // this.basketText = "Thank you, your order has been placed! :)"
    }
  },
  created() {
    this.$store.dispatch('refreshThemeById', {
      themeId: this.$route.params.theme_id
      // slug: this.theme.slug
    })
  },
  components: {
    Theme, 
    Timeline
  }
}
</script>

<style scoped>
#example-one { margin-bottom: 10px; }
[contenteditable="true"] { padding: 10px; outline: 2px dashed #CCC; }
[contenteditable="true"]:hover { outline: 2px dashed #0090D2; }

.checkout-bar {
  position: fixed;
  bottom: 0px;
  background-color: #fff;
  width: 100%;
  height: 160px;
  border-top: 1px solid #ddd;
  padding: 42px 0px;
  z-index: 10;
}

h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
textarea {
  width: 90%;
  border: 1px solid #ddd;
  padding:8px;
  display: block;
}
.admin-panel {
  background-color: #ddd;
  padding: 25px;
  text-align: left;
}
.theme {
  border: 2px solid #587db5;
  width:400px;
  min-height: 200px;
  margin: 25px auto;
  background-color: #4d8ff3;
  color: #fff;
}
.btn-main {
  padding: 12px;
  display: block;
  margin: 8px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Customize.vue